import { annualScore, monthlyScore } from './evaluation-scoring.utils';
import { monthPoints } from './evidence.helper';

/** Aplana la evaluación en listas paralelas de preguntas y respuestas. */
export function flattenEvaluation(evaluation: any[]): { questions: any[]; answers: any[] } {
  const flat = emptyFlat();
  for (const cat of (evaluation || [])) collectCategoryItems(cat, flat);
  return flat;
}

/** Crea el contenedor vacío de preguntas y respuestas. */
function emptyFlat(): { questions: any[]; answers: any[] } {
  return { questions: [], answers: [] };
}

/** Agrega los items de una categoría al acumulado plano. */
function collectCategoryItems(cat: any, flat: { questions: any[]; answers: any[] }): void {
  for (const ans of (cat.answers || [])) collectAnswerItems(ans, flat);
}

/** Agrega una respuesta o sus subitems al acumulado plano. */
function collectAnswerItems(ans: any, flat: { questions: any[]; answers: any[] }): void {
  if (ans.subitems?.length) pushSubs(ans.subitems, flat);
  else pushSingle(ans, flat);
}

/** Agrega cada subitem como pregunta independiente. */
function pushSubs(subs: any[], flat: { questions: any[]; answers: any[] }): void {
  for (const sub of subs) pushSingle(sub, flat);
}

/** Agrega un item individual al acumulado plano. */
function pushSingle(item: any, flat: { questions: any[]; answers: any[] }): void {
  flat.questions.push(item.question);
  flat.answers.push(item);
}

/** Resuelve el puntaje previo según el modo de cálculo. */
export function resolvePreviewScore(
  isAnnual: boolean,
  questions: any[],
  answers: any[],
  goals: Record<string, number>,
  base: Record<string, number>,
): number {
  if (isAnnual) return previewAnnualYtd(questions, answers, goals, base);
  return monthlyScore(questions, answers);
}

/** Calcula el puntaje anual previo con acumulado año a la fecha. */
export function previewAnnualYtd(
  questions: any[],
  answers: any[],
  goalMap: Record<string, number>,
  base: Record<string, number>,
): number {
  return annualScore(questions, buildYtdCumul(questions, answers, base), goalMap);
}

/** Construye el acumulado año a la fecha por pregunta. */
export function buildYtdCumul(
  questions: any[],
  answers: any[],
  base: Record<string, number>,
): Record<string, number> {
  const cumul: Record<string, number> = { ...(base || {}) };
  for (let i = 0; i < questions.length; i++) addYtdPoint(cumul, questions[i], answers[i]);
  return cumul;
}

/** Calcula y guarda el puntaje previo local. */
export function writePreviewScore(state: any, isAnnual: boolean): void {
  const flat = flattenEvaluation(state.evaluation);
  if (!flat.questions.length) return;
  state.period.score = resolvePreviewScore(isAnnual, flat.questions, flat.answers, state.goalNumbers, state.ytdBase);
}

/** Aplica el puntaje en vivo al periodo. */
export function applyLiveScoreTo(state: any, res: any): void {
  if (res?.score == null) return;
  state.period.score = res.score;
  if (res.level != null) state.period.level = res.level;
  if (res.levelColor) state.period.levelColor = res.levelColor;
}

/** Suma los puntos mensuales de una respuesta al acumulado. */
export function addYtdPoint(cumul: Record<string, number>, q: any, a: any): void {
  cumul[q.id] = (cumul[q.id] || 0) + monthPoints(q, a);
}
